import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Switch,
    FormControlLabel
} from '@mui/material';
import api from '../services/api';

interface UserRegisterProps {
    open: boolean;
    onClose: () => void;
    onSave: () => void;
}

const UserRegister: React.FC<UserRegisterProps> = ({ open, onClose, onSave }) => {
    const [formUser, setFormUser] = useState({
        name: '',
        email: '',
        telefone: '',
        role: '',
        ativo: true
    });
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        setLoading(true);
        try {
            await api.post('/api/users/', formUser);
            onSave();
            onClose();
        } catch (error) {
            console.error('Erro ao registrar usuário:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Registrar Novo Usuário</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nome"
                    value={formUser.name}
                    onChange={(e) => setFormUser({ ...formUser, name: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="E-mail"
                    value={formUser.email}
                    onChange={(e) => setFormUser({ ...formUser, email: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Telefone"
                    value={formUser.telefone}
                    onChange={(e) => setFormUser({ ...formUser, telefone: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Perfil"
                    value={formUser.role}
                    onChange={(e) => setFormUser({ ...formUser, role: e.target.value })}
                    fullWidth
                    margin="normal"
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={formUser.ativo}
                            onChange={(e) => setFormUser({ ...formUser, ativo: e.target.checked })}
                        />
                    }
                    label="Ativo"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
                    {loading ? 'Salvando...' : 'Salvar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UserRegister;